const config = {}

config.s3_download_url = "https://s3.us-east-1.amazonaws.com/developer.play.mobile.api.oclc.org"
config.num_releases = null // Show all releases
config.build_machine_name = "oclc-81lvq6ny"

export default config
